import routes from "./routes";
import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
	routes,
	history: createWebHistory(import.meta.env.BASE_URL),
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else if (to.hash) {
			return { selector: to.hash };
		} else {
			return { x: 0, y: 0 };
		}
	},
});

// Before each route evaluates...

export default router;
